import { render, staticRenderFns } from "./session-card.vue?vue&type=template&id=6b2b790e&"
import script from "./session-card.component.ts?vue&type=script&lang=ts&"
export * from "./session-card.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kevinmathieu/crr-sl-fr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2b790e')) {
      api.createRecord('6b2b790e', component.options)
    } else {
      api.reload('6b2b790e', component.options)
    }
    module.hot.accept("./session-card.vue?vue&type=template&id=6b2b790e&", function () {
      api.rerender('6b2b790e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/fo/components/session-card/session-card.vue"
export default component.exports